
import { Vue, Component } from 'vue-property-decorator';
import { getList } from '../api';
import { List } from 'vant';
Vue.use(List);
@Component
export default class Home extends Vue {
  tabs: any = [
    { text: '防疫政策', id: 1 },
    { text: '票务退改', id: 2 },
    { text: '其他求助', id: 3 },
  ];
  id: number = 1;
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;

  show: boolean = true;

  // mounted() {
  //   this.reset();
  // }
  changTab(index: number) {
    this.id = index + 1;
    this.reset();
  }
  goOut() {
    window.location.href = 'https://wap.cqcb.com/shangyou_news/BangBang/QA/ask';
  }

  onLoad() {
    getList(this.id, this.page).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    this.finished = true;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  reset() {
    this.list = [];
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 50);
  }
}
